import React, { useContext } from 'react';
import ProductPageContext from '../../contexts/ProductPageContext';
import analyticsTriggers from '../../analytics/analyticsTriggers';
import useHasGoldenStateAnalytics from '../../helpers/hasGoldenStateAnalytics';
import useHasBundles from './HasBundlesHook';

export default function StyliticsJumpLink({
  testId,
  hasPDPMFEBelowTheFold,
  tmntData,
}) {
  const hasBundles = useHasBundles();
  const hrefLink = hasPDPMFEBelowTheFold ? '#mfe-stylitics-container' : '#stylitics-container';
  const productPageState = useContext(ProductPageContext);
  const hasGoldenStateAnalytics = useHasGoldenStateAnalytics();

  const onStyliticsJumpLinkClick = (event) => {
    event.stopPropagation();
    analyticsTriggers.universalClick('click', 'stylitics-complete-this-look', hasGoldenStateAnalytics, productPageState);
  };

  return (
    hasBundles && (
      <a
        href={hrefLink}
        className="style-it-jumplink"
        data-testid={testId}
        onClick={onStyliticsJumpLinkClick}
      >
        <span className="stylitics-jumplink__text" data-testid="jump-link-main-text">
          {tmntData?.styliticsStyleItText?.value}
        </span>
      </a>
    )
  );
}
